//#region [IMPORT]

import { useEffect, useState } from "react";

//#endregion

//-----------------------------------------------------------------
export default function useOnVisible(ref) {
  //-----------------------------------------------------------------
  //#region [VALUES]

  const [is_visible, setIsVisible] = useState(false); // the state to store the fetched data
  
  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    // create a new intersection observer
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !is_visible) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { 
        threshold: 0.1,
        scrollMargin : "100% 0px 100% 0px",
      }, // the ratio of the element's area that is visible
    );

    // observe the ref element
    observer.observe(ref.current);

    return () => {
      // unobserve the ref element when the component unmounts
      observer.disconnect();
    };
  }, [ref]); // the dependencies of the effect

  //#endregion

  return [is_visible];
};